import { AppBar, Box, Container, Divider, Drawer, IconButton, ListItemButton, ListItemText, Toolbar } from "@mui/material";
import { brandingColors } from "../utils";
import MenuIcon from "@mui/icons-material/Menu";
import CloseIcon from "@mui/icons-material/Close";
import { useState } from "react";
import "./header.css";
import { Link } from "react-router-dom";

export default function Header({showLogo}: any): JSX.Element {
  const [open, setOpenState] = useState(false);
  const className = showLogo ? 'with-logo' : 'without-logo';

  return (
    <div>
        <Container className="header-container">
          <Toolbar className={className}
            sx={{
              display: "flex",
              flexDirection: { xs: "row", md: "row" },
              padding: 0,
            }}
          >
            {showLogo ? (
            <Box
              sx={{
                padding: 0,
              }}
            >
              <Link to="/">
                <img
                  alt=""
                  src="/assets/site-logo.png"
                  height="70px"
                  style={{ objectFit: "cover" }}
                />
              </Link>
            </Box>) : ''}

            <Box
              sx={{
                padding: "10px 20px",
                display: {
                  xs: "none",
                  sm: "flex",
                },
                flexDirection: { xs: "row", md: "row" },
                justifyContent: "space-between",
              }}
            >
              <Link className='btn btn-primary' to="/white-label">
                Use Our Technology
              </Link>
              <Box
                sx={{
                  padding: "10px 0 10px 15px",
                  lineHeight: "28px"
                }}
              >
                <Link to="/about">About us</Link>
              </Box>
              <Box
                sx={{
                  padding: "10px 0 10px 15px",
                  lineHeight: "28px"
                }}
              >
                <a href="/about#work-with-us">Work With us</a>
              </Box>
            </Box>

            <MenuIcon
              onClick={() => setOpenState(true)}
              sx={{
                mr: 2,
                display: {
                  xs: "block",
                  sm: "none",
                },
              }}
            />

            {/* The outside of the drawer */}
            <Drawer
              //from which side the drawer slides in
              anchor="right"
              //if open is true --> drawer is shown
              open={open}
              //function that is called when the drawer should close
              onClose={() => setOpenState(false)}
            >
              {/* The inside of the drawer */}
              <Box
                sx={{
                  p: 2,
                  height: 1
                }}
              >
                {/* when clicking the icon it calls the function toggleDrawer and closes the drawer by setting the variable open to false */}
                <IconButton sx={{ mb: 2 }}>
                  <CloseIcon onClick={() => setOpenState(false)} />
                </IconButton>

                <Divider sx={{ mb: 2 }} />

                <Box sx={{ mb: 2 }}>
                  <ListItemButton>
                    <Link className='btn btn-primary' to="/white-label">
                      Use Our Technology
                    </Link>
                  </ListItemButton>

                  <ListItemButton>
                    <Link to="/about">
                      <ListItemText className="menu-item" primary="About Us" />
                    </Link>
                  </ListItemButton>

                  <ListItemButton>
                    <a href="/about#work-with-us">
                      <ListItemText className="menu-item" primary="Work with us" />
                    </a>
                  </ListItemButton>
                </Box>
              </Box>
            </Drawer>
          </Toolbar>
        </Container>
      </div>
  )
}